/**
 * Shared email capture form handler for FUMO sections.
 *
 * Usage:
 *   FumoEmailForm.init({
 *     root: element,             // Container with [data-form-content] + [data-form-confirmation]
 *     formSelector: 'form',      // CSS selector for form(s) within root
 *     confirmOnError: false,     // Show confirmation even on error (tech debt: footer, collection-grid)
 *     acceptHeader: 'application/json',
 *     loadingText: 'Sending\u2026',
 *     errorText: 'Something went wrong. Please try again.',
 *     confirmationClass: null,   // CSS class added to confirmation el after reflow
 *     onSuccess: null            // Optional callback({ email, root })
 *   });
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var DEFAULTS = {
    formSelector: 'form',
    confirmOnError: false,
    acceptHeader: 'application/json',
    loadingText: 'Sending\u2026',
    errorText: 'Something went wrong. Please try again.',
    confirmationClass: null,
    onSuccess: null,
  };

  function initForm(form, config) {
    if (form.hasAttribute('data-fumo-email-bound')) return;
    form.setAttribute('data-fumo-email-bound', '');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.hasAttribute('data-fumo-submitting')) return;

      /* Honeypot */
      var hp = form.querySelector('[data-fumo-hp]') || form.querySelector('[name="contact[honeypot]"]');
      if (hp && hp.value) return;

      /* Email validation */
      var emailInput = form.querySelector('[data-fumo-email]') || form.querySelector('[name="contact[email]"]');
      var errorEl = form.querySelector('[data-visible]');
      var email = emailInput ? emailInput.value.trim() : '';

      if (!email || !EMAIL_RE.test(email)) {
        if (errorEl) errorEl.setAttribute('data-visible', 'true');
        if (emailInput) emailInput.focus();
        return;
      }

      if (errorEl) errorEl.setAttribute('data-visible', 'false');
      form.setAttribute('data-fumo-submitting', '');

      /* Button loading state */
      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = config.loadingText;
      }

      /* Find content / confirmation containers */
      var wrapper =
        form.closest('[data-email-form]') ||
        form.closest('[data-notify-form]') ||
        form.closest('[data-newsletter-form]') ||
        form.parentElement;
      var formContent = wrapper.querySelector('[data-form-content]');
      var confirmation = wrapper.querySelector('[data-form-confirmation]');

      function showConfirmation() {
        if (formContent) formContent.style.display = 'none';
        if (confirmation) {
          confirmation.style.display = 'block';
          if (config.confirmationClass) {
            void confirmation.offsetHeight;
            confirmation.classList.add(config.confirmationClass);
          }
        }
        if (config.onSuccess) {
          config.onSuccess({ email: email, root: wrapper });
        }
      }

      function handleError() {
        form.removeAttribute('data-fumo-submitting');
        if (config.confirmOnError) {
          showConfirmation();
          return;
        }
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
        if (errorEl) {
          errorEl.textContent = config.errorText;
          errorEl.setAttribute('data-visible', 'true');
        }
        if (emailInput) {
          emailInput.addEventListener('focus', function clearErr() {
            if (errorEl) errorEl.setAttribute('data-visible', 'false');
            emailInput.removeEventListener('focus', clearErr);
          });
        }
      }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: config.acceptHeader },
      })
        .then(showConfirmation)
        .catch(handleError);
    });
  }

  window.FumoEmailForm = {
    init: function (opts) {
      var config = {};
      var key;
      for (key in DEFAULTS) config[key] = DEFAULTS[key];
      for (key in opts) config[key] = opts[key];

      var root = config.root;
      if (!root) return;

      var forms = root.querySelectorAll(config.formSelector);
      for (var i = 0; i < forms.length; i++) {
        initForm(forms[i], config);
      }
    },
  };
})();
